import React, { useCallback, useState, useEffect } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { RiBankFill } from 'react-icons/ri';
import { MdKeyboardBackspace } from 'react-icons/md';

import { IRouterParams } from 'shared/interfaces';

import { useToast } from 'contexts';

import * as C from 'components';
import * as S from './styles';

import {
  createPlanoContasPai,
  getPlanoContasPai,
  updatePlanoContasPai,
} from '../api';
import { IPlanoContasPai, IPlanoContasPaiForm } from '../interfaces';

const schema = Yup.object().shape({
  nome: Yup.string().required('Descrição obrigatória'),
});

export const PlanoContasPaiForm: React.FC = () => {
  const history = useHistory();
  const { addToast } = useToast();

  const { id } = useParams<IRouterParams>();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IPlanoContasPaiForm>({
    defaultValues: {
      nome: '',
    },
    resolver: yupResolver(schema),
  });

  const [loading, setLoading] = useState(false);
  const [planoContasPai, setPlanoContasPai] = useState<IPlanoContasPai>();

  useEffect(() => {
    if (id) {
      getPlanoContasPai(id).then((data) => {
        setPlanoContasPai(data);

        reset(data);
      });
    }
  }, [id, reset]);

  const onSubmit = useCallback(
    async (data: IPlanoContasPai) => {
      try {
        setLoading(true);

        if (id) {
          const response = await updatePlanoContasPai(id, data);

          if (response) {
            addToast({
              type: 'success',
              title: 'Atualizado',
              description: 'Atualizado com sucesso',
            });

            history.push('/plano-contas-pai');
          }
        } else {
          await createPlanoContasPai(data);

          addToast({
            type: 'success',
            title: 'Sucesso',
            description: 'Salvo com sucesso',
          });

          reset();

          history.push('/plano-contas-pai');
        }
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Ops, Erro',
          description: 'Ocorreu um erro ao inserir um novo registro',
        });
      } finally {
        setLoading(false);
      }
    },

    [addToast, history, id, reset],
  );

  return (
    <S.Container>
      <C.HeaderBackground>
        <S.HeaderPageDatail>
          <S.BackLink>
            <Link to="/plano-contas-pai">
              <MdKeyboardBackspace size={24} color="#fff" />
              Plano contas pai
            </Link>
          </S.BackLink>

          <C.HeaderInfo
            title={
              id
                ? `Editando: ${planoContasPai?.nome}`
                : 'Novo plano de contas pai'
            }
            icon={RiBankFill}
          />
        </S.HeaderPageDatail>
      </C.HeaderBackground>

      <S.Panel>
        <form onSubmit={handleSubmit(onSubmit)}>
          <C.FormGroup>
            <C.Label>Descrição</C.Label>
            <C.Input
              type="text"
              {...register('nome')}
              errors={errors.nome}
              name="nome"
              placeholder="Descrição"
            />
          </C.FormGroup>

          <C.Button
            variant="primary"
            disabled={loading}
            loading={loading}
            type="submit"
            title="Salvar"
          >
            Salvar
          </C.Button>
        </form>
      </S.Panel>
    </S.Container>
  );
};
